import { BaseStatementPagePath } from 'app/core/workflow/page-path/statement-page-path/base-statement-page.path';

export class DeductionInfoComponentPath extends BaseStatementPagePath {
  public static path(): string {
    return 'statement/:statementId/b2c/deduction-info/:step';
  }

  public static regex(step?: number): RegExp {
    return this.componentRegex(this.path(), null, step);
  }
}
